/**
 * Este archivo se hizo por aparte por la imposibilidad de importar
 * los archivos de campaña desde webpack
 * No se generan automáticamente porque algunos son levemente diferentes
 */

module.exports = {
  ofertaDigital: {
    titulo: "Plazo Fijo | BBVA Argentina",
    descripcion:
      "Conocé nuestro simulador de Plazo Fijo en dólares o pesos y calculá los intereses de tu inversión junto al BBVA",
    robots: "noindex, nofollow",
  },
  ofertaCliente: {
    titulo: "Simulador de Plazo Fijo | BBVA Argentina",
    descripcion:
      "Conocé nuestro simulador de Plazo Fijo en dólares o pesos y calculá los intereses de tu inversión junto al BBVA",
    robots: "index, follow",
  },
};
